import { __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { callServiceAndFormulateLogMessageResult, formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for handling files messages
 */
var FilesMessageHandler = /** @class */ (function (_super) {
    __extends(FilesMessageHandler, _super);
    function FilesMessageHandler(appSdkHost, filesService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.filesService = filesService;
        return _this;
    }
    FilesMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.files.openFilePreview, function (_) {
            var params = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                params[_i - 1] = arguments[_i];
            }
            var filePreviewParams = {
                entityId: params[0],
                title: params[1],
                description: params[2],
                type: params[3],
                objectUrl: params[4],
                downloadUrl: params[5],
                webPreviewUrl: params[6],
                webEditUrl: params[7],
                baseUrl: params[8],
                editFile: params[9],
                subEntityId: params[10],
                viewerAction: params[11],
                fileOpenPreference: params[12],
            };
            if (!filePreviewParams.type || !filePreviewParams.objectUrl) {
                return Promise.reject('Invalid File Preview Parameters');
            }
            return callServiceAndFormulateLogMessageResult(_this.filesService.openFilePreview, filePreviewParams);
        }, {
            isRestrictedToFullTrustOrLobApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.getCloudStorageFolders, function (_, channelId) { return formulateSdkResponse(channelId, _this.filesService.getCloudStorageFolders); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.getCloudStorageFolders, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.addCloudStorageFolder, function (_, channelId) {
            return formulateSdkResponse(channelId, _this.filesService.addCloudStorageFolder, function (result) { return [result.isFolderAdded, result.folders]; }, true /* spreadFinalResult */);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.addCloudStorageFolder, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.deleteCloudStorageFolder, function (_, channelId, folderToDelete) {
            return formulateSdkResponse({ channelId: channelId, folderToDelete: folderToDelete }, _this.filesService.deleteCloudStorageFolder);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.deleteCloudStorageFolder, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.copyMoveFiles, function (_, selectedFiles, providerCode, destinationFolder, destinationProviderCode, isMove) {
            return formulateSdkResponse({ selectedFiles: selectedFiles, providerCode: providerCode, destinationFolder: destinationFolder, destinationProviderCode: destinationProviderCode, isMove: isMove }, _this.filesService.copyMoveFiles);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.copyMoveFiles, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.getExternalProviders, function (_, excludeAddedProviders) {
            if (excludeAddedProviders === void 0) { excludeAddedProviders = false; }
            return formulateSdkResponse(excludeAddedProviders, _this.filesService.getExternalProviders);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.getExternalProviders, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.getCloudStorageFolderContents, function (_, folder, providerCode) {
            return formulateSdkResponse({ folder: folder, providerCode: providerCode }, _this.filesService.getCloudStorageFolderContents);
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.files.getCloudStorageFolderContents, error, scenario);
            },
            isRestrictedToFullTrustApps: true,
        });
        this.registerHandler(SdkMessageTypes.files.openCloudStorageFile, function (_, file, providerCode, fileOpenPreference) {
            return formulateSdkResponse({ file: file, providerCode: providerCode, fileOpenPreference: fileOpenPreference }, _this.filesService.openCloudStorageFile);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.files.openCloudStorageFile, error, scenario); },
            isRestrictedToFullTrustApps: true,
        });
    };
    FilesMessageHandler.prototype.validateDependencies = function () {
        if (!this.filesService) {
            throw 'No FilesService provided';
        }
    };
    return FilesMessageHandler;
}(BaseMessageHandler));
export { FilesMessageHandler };
//# sourceMappingURL=files-message-handler.js.map